{
  "name": "auctionator-frontend",
  "version": "2.0.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "codegen": "graphql-codegen --config codegen.ts",
    "test:node": "node --test tests/*.test.ts"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^22.2.3",
    "@angular/common": "^22.2.3",
    "@angular/compiler": "^22.2.3",
    "@angular/core": "^22.2.3",
    "@angular/forms": "^22.2.3",
    "@angular/platform-browser": "^22.2.3",
    "@angular/platform-browser-dynamic": "^22.2.3",
    "@angular/router": "^22.2.3",
    "@apollo/client": "^4.3.5",
    "apollo-angular": "^14.2.0",
    "apollo3-cache-persist": "^0.14.1",
    "google-libphonenumber": "^3.2.44",
    "graphql": "^16.14.2",
    "intl-tel-input": "27.3.1",
    "ngx-infinite-scroll": "^22.0.0",
    "ngx-intl-tel-input-gg": "2.0.1",
    "ngx-toastr": "^20.0.5",
    "rollbar": "^2.26.2",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular/build": "^22.2.4",
    "@angular/cli": "~22.2.4",
    "@angular/compiler-cli": "^22.2.3",
    "@graphql-codegen/cli": "^4.0.1",
    "@graphql-codegen/fragment-matcher": "5.0.0",
    "@graphql-codegen/introspection": "4.0.0",
    "@graphql-codegen/typescript": "^4.0.0",
    "@graphql-codegen/typescript-apollo-angular": "^3.5.6",
    "@graphql-codegen/typescript-operations": "^4.0.0",
    "@types/jasmine": "~4.3.0",
    "istanbul-lib-instrument": "^6.0.3",
    "jasmine-core": "~4.5.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.1.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.0.0",
    "typescript": "~6.0.3"
  },
  "resolutions": {
    "browserslist": "^4.29.4",
    "lodash": "^4.18.1",
    "postcss": "^8.5.31",
    "ws": "^8.22.0",
    "@graphql-typed-document-node/core": "^3.2.0"
  },
  "scarfSettings": {
    "enabled": false
  }
}
